import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@cvent/blocks/components/BlockAvatar';
import Button from '@cvent/carina/components/Button';
import { Col } from '@cvent/carina/components/Col';
import { Row } from '@cvent/carina/components/Row';
import { useTranslate } from 'nucleus-text';
import useBreakpoints from '@hooks/useBreakpoints';
import useTheme from '@cvent/blocks/hooks/useTheme';
import { injectTestId } from '@cvent/nucleus-test-automation';
import Typography from '@cvent/blocks/components/Typography';

const useStyles = ({ forMobileTakeover }) => {
  const { font } = useTheme();
  const { isM, isL, isXL, widthWindow } = useBreakpoints();
  const isDesktop = isM || isL || isXL;
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      paddingTop: 16,
      paddingBottom: 24,
      paddingLeft: forMobileTakeover ? 0 : 16,
      paddingRight: 16
    },
    innerContainer: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      paddingLeft: 16,
      maxWidth: isDesktop ? widthWindow / 2 : null,
      minWidth: 220
    },
    truncateText: {
      fontSize: font.base.size.m,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    attendeeName: {
      margin: 0,
      textTransform: 'none'
    },
    logoutButton: {
      paddingTop: 12
    }
  };
};

const ProfileLogout = ({
  attendeeName,
  avatarName,
  attendeeEmail,
  attendeeProfilePhotoSrc,
  onLogout,
  forMobileTakeover = false
}) => {
  const styles = useStyles({ forMobileTakeover });
  const { translate } = useTranslate();
  return (
    <div {...injectTestId('attendee-profile')} css={styles.container}>
      <Row>
        <Col padding={0} width="content">
          <Avatar
            text={avatarName}
            image={attendeeProfilePhotoSrc}
            size={forMobileTakeover ? 4 : 3}
          />
        </Col>
        <Col padding={0} width="fill">
          <div css={styles.innerContainer}>
            <Typography
              as="h2"
              styledAs="h5"
              {...injectTestId('attendee-name')}
              css={[styles.attendeeName, styles.truncateText]}
            >
              {attendeeName}
            </Typography>

            <span {...injectTestId('attendee-email')} css={styles.truncateText}>
              {attendeeEmail}
            </span>
            <div css={styles.logoutButton}>
              <Button
                text={translate('Navigation-Menu-LogoutButton')}
                onClick={onLogout}
                appearance="lined"
                size="s"
                testID="navigation-menu-logout"
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

ProfileLogout.propTypes = {
  attendeeName: PropTypes.string,
  avatarName: PropTypes.string,
  attendeeEmail: PropTypes.string,
  attendeeProfilePhotoSrc: PropTypes.string,
  onLogout: PropTypes.func.isRequired,
  forMobileTakeover: PropTypes.bool
};

export default ProfileLogout;
